__turbopack_context__.v({
  "dissolved": "spoilerFog-module-scss-module__UGd7zq__dissolved",
  "fog": "spoilerFog-module-scss-module__UGd7zq__fog",
  "fog-drift": "spoilerFog-module-scss-module__UGd7zq__fog-drift",
  "fogged": "spoilerFog-module-scss-module__UGd7zq__fogged",
  "label": "spoilerFog-module-scss-module__UGd7zq__label",
  "spoilerFog": "spoilerFog-module-scss-module__UGd7zq__spoilerFog",
  "veil": "spoilerFog-module-scss-module__UGd7zq__veil",
});
